import styled from 'styled-components';

import { Button } from '../../../../../components';
import { ThemeProp } from '../../../../../theme/Themes';

export const ChipsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: none;
  }
`;

export const ClearAllButton = styled(Button).attrs((props: ThemeProp & { css: any }) => ({
  ...props,
  ripple: false,
  css: {
    ...props.css,
    gap: '0.2rem',
    background: 'transparent',
    padding: '0.625rem 0.5rem',
    width: 'auto',
    minWidth: 0,
    height: '2rem',
    borderRadius: '0.375rem',
    '&:focus': {
      background: 'transparent',
    },
    '&:hover': {
      background: 'transparent',
    },
  },
}))`
  & .nextui-button-text {
    color: ${({ theme }: ThemeProp) => theme.colors.main.c600};
    font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
    line-height: 1.1375rem;
  }
`;
